import React from 'react';
import { MdArrowBack } from 'react-icons/md';
// import OTPInput from './OTPInput';
import styles from './Login.module.css';
import OTPInput from './OtpInput';

const OTPStep = ({
    email,
    otp,
    setOtp,
    onSubmit,
    onBack,
    onResend,
    loading,
    error,
    resendTimer
}) => {
    return (
        <form onSubmit={onSubmit} className={styles.form}>
            <button
                type="button"
                className={styles.backButton}
                onClick={onBack}
                disabled={loading}
            >
                <MdArrowBack /> Back to email
            </button>

            <div className={styles.otpHeader}>
                <h4 className={styles.otpTitle}>Verify your email</h4>
                <p className={styles.otpSubtitle}>
                    Enter the 6-digit code sent to<br />
                    <strong>{email}</strong>
                </p>
            </div>

            <OTPInput
                otp={otp}
                setOtp={setOtp}
                loading={loading}
            />

            {error && (
                <div className={styles.errorAlert}>
                    <span className={styles.errorIcon}>⚠</span>
                    <span>{error}</span>
                </div>
            )}

            <button
                type="submit"
                className={styles.submitBtn}
                disabled={loading || otp.join('').length !== 6}
            >
                {loading ? (
                    <>
                        <span className={styles.spinner}></span>
                        Verifying...
                    </>
                ) : (
                    'Verify & Sign In'
                )}
            </button>

            <div className={styles.resendSection}>
                {resendTimer > 0 ? (
                    <p className={styles.resendTimer}>
                        Resend code in <strong>{resendTimer}s</strong>
                    </p>
                ) : (
                    <p className={styles.resendText}>
                        Didn't receive the code?{' '}
                        <button
                            type="button"
                            onClick={onResend}
                            className={styles.resendBtn}
                            disabled={loading}
                        >
                            Resend
                        </button>
                    </p>
                )}
            </div>
        </form>
    );
};

export default OTPStep;